import gql from "graphql-tag";

export default gql`
  mutation($orderID: ID!, $printFileIDs: [ID!]!) {
    removePersonalizedPrintFiles(orderID: $orderID, printFileIDs: $printFileIDs)
  }
`;
